module.exports = "pegasus_template/assets/image-4-basic.png";